import { defineMessage } from 'react-intl';

export const inviteI18n = {
  acceptCustomerInviteButton: defineMessage({
    id: 'invite.customer.accept-button',
    defaultMessage: 'Join business'
  }),
  acceptCustomerInviteTitle: defineMessage({
    id: 'invite.customer.acceptance-title',
    defaultMessage: '{org} has invited {customer} to join as a customer'
  })
};
